module.exports = __webpack_public_path__ + "static/img/King of Pentacles.56211b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/King of Pentacles.jpg
// module id = 1276
// module chunks = 0